import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-banner",
  "use": "icon-banner-usage",
  "viewBox": "0 0 1032 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1032 1024\" id=\"icon-banner\"><defs><style type=\"text/css\"></style></defs><path d=\"M805.161 152.774H202.323c-28.904 0-49.549 20.645-49.549 49.549V809.29c0 28.904 20.645 49.549 49.549 49.549H809.29c28.904 0 49.549-20.645 49.549-49.549V206.452c0-28.904-24.774-53.678-53.678-53.678zM202.323 813.42c0-4.129 0-4.129 0 0z m602.838-4.129L611.097 602.84l-94.968 82.58-144.516-136.258L227.097 685.42l-20.645 24.775V206.452h606.967V809.29zM648.258 507.871c53.677 0 94.968-41.29 94.968-94.968 0-53.677-41.29-94.968-94.968-94.968-53.677 0-94.968 41.29-94.968 94.968 0 49.549 41.29 94.968 94.968 94.968zM119.742 272.516v-49.548H57.806c-28.903 0-49.548 20.645-49.548 49.548v466.58c0 28.904 20.645 49.55 49.548 49.55h61.936v-49.55H57.806v-466.58h61.936z m763.87 466.58v49.55h66.065c28.904 0 49.549-20.646 49.549-49.55v-466.58c0-28.903-20.645-49.548-49.549-49.548h-61.935v49.548h61.935v466.58h-66.064z\" fill=\"#515151\" p-id=\"14079\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/banner.svg
// module id = DXJQ
// module chunks = 47